export const formActions = {
	cancel: "Cerrar",
	create: "Completar registro",
	save: "Guardar cambios",
	validationError: {
		title: "Error de validación del formulario",
		description:
			"Por favor corrija {{count}} error(es) en las siguientes pestañas: {{tabs}}",
	},
};
